import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const NilfluenceScorePage = loadable(() => import(/* webpackChunkName: "NilfluenceScorePage" */ '../containers/NilfluenceScorePage/NilfluenceScorePage'));
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const AssociatedListingPage = loadable(() => import(/* webpackChunkName: "AssociatedListingPage" */ '../containers/AssociatedListingPage/AssociatedListingPage'));
const BrandOfferingPage = loadable(() => import(/* webpackChunkName: "BrandOfferingPage" */ '../containers/BrandOfferingPage/BrandOfferingPage'));
const BrandsOnboardingPage = loadable(() => import(/* webpackChunkName: "BrandsOnboardingPage" */ '../containers/BrandsOnboardingPage/BrandsOnboardingPage'));
const BulkUploadUsersPage = loadable(() => import(/* webpackChunkName: "BulkUploadUsersPage" */ '../containers/BulkUploadUsersPage/BulkUploadUsersPage'))
const CampaignPostingPage = loadable(() => import(/* webpackChunkName: "CampaignPostingPage" */ '../containers/CampaignPostingPage/CampaignPostingPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const FavoritesPage = loadable(() => import(/* webpackChunkName: "FavoritesPage" */ '../containers/FavoritesPage/FavoritesPage'));
const FavoritesDetailsPage = loadable(() => import(/* webpackChunkName: "FavoritesDetailsPage" */ '../containers/FavoritesDetailsPage/FavoritesDetailsPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const InboxBasePage = loadable(() => import(/* webpackChunkName: "InboxBasePage" */ '../containers/InboxPage/InboxBasePage'));
const JobPostPage = loadable(() => import(/* webpackChunkName: "JobPostPage" */ '../containers/JobPostPage/JobPostPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const LinkTalentPage = loadable(() => import(/* webpackChunkName: "LinkTalentPage" */ /* webpackPrefetch: true */ '../containers/LinkTalentPage/LinkTalentPage'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const ManageSubscriptionPage = loadable(() => import(/* webpackChunkName: "ManageSubscriptionPage" */ '../containers/ManageSubscriptionPage/ManageSubscriptionPage'));
const MessagesPage = loadable(() => import(/* webpackChunkName: "MessagesPage" */ '../containers/MessagesPage/MessagesPage'));
const OrdersListViewPage = loadable(() => import(/* webpackChunkName: "OrdersListViewPage" */ '../containers/OrdersListViewPage/OrdersListViewPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PhylloConnectPage = loadable(() => import(/* webpackChunkName: "PhylloConnectPage" */ '../containers/PhylloConnectPage/PhylloConnectPage'));
const PerksPostPage = loadable(() => import(/* webpackChunkName: "PerksPostPage" */ '../containers/PerksPostPage/PerksPostPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const ReferralPage = loadable(() => import(/* webpackChunkName: "ReferralPage" */ '../containers/ReferralPage/ReferralPage'));
const RewardsPage = loadable(() => import(/* webpackChunkName: "RewardsPage" */ '../containers/RewardsPage/RewardsPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const ServiceOfferingsPage = loadable(() => import(/* webpackChunkName: "ServiceOfferingsPage" */ /* webpackPrefetch: true */  '../containers/ServiceOfferingsPage/ServiceOfferingsPage'));
const SportsPage = loadable(() => import(/* webpackChunkName: "SportsPage" */ /* webpackPrefetch: true */  '../containers/SportsPage/SportsPage'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const SubscriptionPage = loadable(() => import(/* webpackChunkName: "SubscriptionPage" */ '../containers/SubscriptionPage/SubscriptionPage'));
const TalentOfferingPage = loadable(() => import(/* webpackChunkName: "TalentOfferingPage" */ '../containers/TalentOfferingPage/TalentOfferingPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));

// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
export const draftId = '00000000-0000-0000-0000-000000000000';
export const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig) => {
  const SearchPage = layoutConfig?.searchPage?.variantType === 'map'
    ? SearchPageWithMap
    : SearchPageWithGrid;
  const ListingPage = layoutConfig?.listingPage?.variantType === 'carousel'
    ? ListingPageCarousel
    : ListingPageCoverPhoto;

  return [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/brand-offering',
      name: 'BrandOfferingPage',
      component: BrandOfferingPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.BrandOfferingPage.loadData,
    },
    {
      path: '/orders-list-view',
      name: 'OrdersListViewPage',
      component: OrdersListViewPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.OrdersListViewPage.loadData,
    },
    {
      path: '/associated-listing/:id',
      name: 'AssociatedListingPage',
      component: AssociatedListingPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.AssociatedListingPage.loadData,
    },
    {
      path: '/service-offering/:id/:type',
      name: 'ServiceOfferingsPage',
      component: ServiceOfferingsPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.ServiceOfferingsPage.loadData,
    },
    {
      path: '/phyllo-connect',
      name: 'PhylloConnectPage',
      component: PhylloConnectPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.PhylloConnectPage.loadData,
    },
    {
      path: '/referral',
      name: 'ReferralPage',
      component: ReferralPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.ReferralPage.loadData,
    },
    {
      path: '/link-talent/:tab',
      name: 'LinkTalentPage',
      component: LinkTalentPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.LinkTalentPage.loadData,
    },
    {
      path: '/talent-offering',
      name: 'TalentOfferingPage',
      component: TalentOfferingPage,
      auth: true,
      authPage: 'LoginPage',
      loadData: pageDataLoadingAPI.TalentOfferingPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      path: '/s',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/sports',
      name: 'SportsPage',
      component: SportsPage,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },

    {
      path: '/job/new/:slug/:id/:type',
      name: 'JobPostPage',
      auth: true,
      authPage: 'LoginPage',
      component: JobPostPage,
      loadData: pageDataLoadingAPI.JobPostPage.loadData,

    },
    {
      path: '/job/edit/:slug/:id/:type',
      name: 'EditJobPostPage',
      auth: true,
      authPage: 'LoginPage',
      component: JobPostPage,
      loadData: pageDataLoadingAPI.JobPostPage.loadData,

    },
    {
      path: '/rewards/new/:slug/:id/:type',
      name: 'RewardsPage',
      auth: true,
      authPage: 'LoginPage',
      component: RewardsPage,
      loadData: pageDataLoadingAPI.RewardsPage.loadData,

    },
    {
      path: '/rewards/edit/:slug/:id/:type',
      name: 'EditRewardsPage',
      auth: true,
      authPage: 'LoginPage',
      component: RewardsPage,
      loadData: pageDataLoadingAPI.RewardsPage.loadData,

    },
    {
      path: '/campaign/new/:slug/:id/:type',
      name: 'CampaignPostingPage',
      auth: true,
      authPage: 'LoginPage',
      component: CampaignPostingPage,
      loadData: pageDataLoadingAPI.CampaignPostingPage.loadData,

    },
    {
      path: '/campaign/edit/:slug/:id/:type',
      name: 'EditCampaignPostingPage',
      auth: true,
      authPage: 'LoginPage',
      component: CampaignPostingPage,
      loadData: pageDataLoadingAPI.CampaignPostingPage.loadData,

    },

    {
      path: '/perks/new/:slug/:id/:type',
      name: 'PerksPostPage',
      auth: true,
      authPage: 'LoginPage',
      component: PerksPostPage,
      loadData: pageDataLoadingAPI.PerksPostPage.loadData,

    },
    {
      path: '/perks/edit/:slug/:id/:type',
      name: 'EditPerksPostPage',
      auth: true,
      authPage: 'LoginPage',
      component: PerksPostPage,
      loadData: pageDataLoadingAPI.PerksPostPage.loadData,

    },
     {
      path: '/favorites',
      name: 'FavoritesPage',
      auth: true,
      authPage: 'LoginPage',
      component: FavoritesPage,
      loadData: pageDataLoadingAPI.FavoritesPage.loadData,
    },
     {
      path: '/favorites-details/:type',
      name: 'FavoritesDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: FavoritesDetailsPage,
      loadData: pageDataLoadingAPI.FavoritesDetailsPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },
    {
      path: '/getting-started',
      name: 'BrandsOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: BrandsOnboardingPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxBasePage,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/messages',
      name: 'MessagesBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: MessagesPage,
      loadData: pageDataLoadingAPI.MessagesPage.loadData,
    },
    {
      path: '/messages/:id',
      name: 'MessagesPage',
      auth: true,
      authPage: 'LoginPage',
      component: MessagesPage,
      loadData: pageDataLoadingAPI.MessagesPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/order/:id/chat',
      name: 'OrderDetailsPageChatRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id/chat',
      name: 'SaleDetailsPageChatRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/subscription',
      name: 'SubscriptionPage',
      auth: true,
      authPage: 'LoginPage',
      component: SubscriptionPage,
      loadData: pageDataLoadingAPI.SubscriptionPage.loadData,

    },
    {
      path: '/account/manage-subscription',
      name: 'ManageSubscriptionPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageSubscriptionPage,
      loadData: pageDataLoadingAPI.ManageSubscriptionPage.loadData,

    },
    {
     path: '/bulk-upload-users/:id',
     name: 'BulkUploadUsersPage',
     auth: true,
     authPage: 'LoginPage',
     component: BulkUploadUsersPage,
     loadData: pageDataLoadingAPI.BulkUploadUsersPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage ,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage ,
    },   {
      path: '/nilfluence-score',
      name: 'NilfluenceScorePage',
      component: NilfluenceScorePage ,
    },

  ];
};

export default routeConfiguration;
